import {BannerDataText} from '@core-client/ads/banner/data/BannerDataText';

import {BannerRenderer} from './BannerRenderer';

export class TextBannerRenderer extends BannerRenderer {
    showBannerDiv(banner: BannerDataText) {
        this.bannerView.showContainer();
        this.bannerView.setBannerHtml(banner.text);
    }
}
